import { render } from "./FriendRequest.vue?vue&type=template&id=b5d17e24"
import script from "./FriendRequest.vue?vue&type=script&lang=js"
export * from "./FriendRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__